module.exports = __webpack_public_path__ + "media/Video 59.3f7df9d3.mp4";